export const COMMENT_TYPES = {
  USER: "user",
  SYSTEM: "system",
  NIGO: "nigo",
};
